module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"history":"Публичная оферта"}}')
  delete Component.options._Ctor
}
